module.exports = __webpack_public_path__ + "assets/img/show.8e29876e.png";